import MagicSignupEdgeCasesPage from "@faire/prototype-playground/workspace/kar/magic-signup-edge-cases";
import { Route, Switch } from "react-router-dom";

export function KanikaAroraRoutes() {
  return (
    <Switch>
      <Route
        path="/kar/magic-signup-edge-cases"
        component={MagicSignupEdgeCasesPage}
      />
    </Switch>
  );
}

export const slug = "kar";
